import axios, { AxiosError, AxiosResponse } from 'axios';
import * as Sentry from "@sentry/browser";

// Сериализация как в версиях axios до 1.x.x
const isObject = (value: any) => {
  return typeof value === 'object'
  && value !== null
  && !Array.isArray(value)
  && !(value instanceof RegExp)
  && !(value instanceof Date)
  && !(value instanceof Set)
  && !(value instanceof Map)
}

const paramsSerializer = (params: any) =>
  Object.keys(params)
    .filter(key => params[key] !== undefined &&  params[key] !== null)
    .map(key => {
      if (isObject(params[key])) {
        params[key] = JSON.stringify(params[key]);
      }
      if (Array.isArray(params[key])) {
        return params[key].map((v: any) => `${key}[]=${encodeURIComponent(v)}`).join('&');
      }
      return `${key}=${encodeURIComponent(params[key])}`;
    })
    .join('&');

const http = axios.create({
    headers: { "X-Requested-With": "XMLHttpRequest" },
    paramsSerializer: paramsSerializer,
});

axios.interceptors.response.use(
    (response: AxiosResponse) => response,
    (error: AxiosError) => {
      if (error.response) {
        Sentry.captureException(error.response.data);
      } else {
        Sentry.captureException(error.message);
      }
      Sentry.captureException(error);
      return Promise.reject(error);
    },
  );

export const gw = axios.create({
    baseURL: process.env.GW_SERVICE_LINK,
    headers: {
        Authorization: `Bearer ${window._user._aut}`
    }
})

export default http;
